
import { useHistory, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import type React from 'react'

export type Navigate = (path: string, replace?: boolean) => void

const useNavigateWithScrollSave = (
  expanded: boolean,
  contentRef: React.RefObject<HTMLDivElement | null>
) => {
  const { pathname } = useLocation()
  const history = useHistory()

  const navigate: Navigate = (path, replace) => {
    if (contentRef.current) {
      const scrollPos = contentRef.current.scrollTop
      window.history.replaceState({ ...(window.history.state || {}), scrollPos, expanded }, '')
    }
    const action = replace ? history.replace : history.push
    action(path)
  }

  useEffect(() => {
    const content = contentRef.current
    const state = window.history.state
    const scrollPos = state && typeof state === 'object' && 'scrollPos' in state
      ? state.scrollPos
      : undefined
    if (content && scrollPos) {
      content.scrollTop = scrollPos
    }
  }, [contentRef, pathname])

  useEffect(() => {
    const state = window.history.state
    if (!expanded && typeof state === 'object' && state?.expanded) {
      const { expanded, scrollPos, ...rest } = state
      window.history.replaceState(rest, '')
    }
  }, [expanded])

  return navigate
}

export const checkIsMenuExpanded = () => {
  return window.history.state && typeof window.history.state === 'object' && 'expanded' in window.history.state && window.history.state.expanded
}

export default useNavigateWithScrollSave